import type { Theme } from '@mui/material/styles'

const MuiCheckbox = (baseTheme: Theme) => ({
  styleOverrides: {
    root: {
      padding: baseTheme.spacing(0, 0.25),

      '& > svg': {
        fontSize: baseTheme.spacing(2),
      },
    },
  },
})

export default MuiCheckbox
